"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var deeply_1 = require("./deeply");
var transform = function (transformer) { return function (input) {
    return deeply_1.default(lodash_1.mapKeys)(input, function (value, key) { return transformer(key); });
}; };
exports.toSnakeCase = transform(lodash_1.snakeCase);
exports.toCamelCase = transform(lodash_1.camelCase);
//# sourceMappingURL=transform.js.map